import React from 'react';

import PropTypes from 'prop-types';
import withAuth from '../../hocs/withAuth';
import { getPickleBallRating, getRatingDetails, getRatingProgressDisplay, setRatingChoice } from '../../../utils';
import { getOrganizerRating } from '../../../utils/events';
import PbrRating from '../PbrRating';
import { MatchFormatTypes } from '../../../utils/postScoreConstants';
import { sportTypeIds } from '../../../utils/eventConstants';

/** force:
 * - ratingType: singles/doubles
 * - utrType: sanctioned/myUtr
 * - verifiedIcon: true (show verified badge for verified rating)
 */

const UtrNumber = (props) => {
    const {
        player,
        auth,
        pbrClass,
        isProgressionDraw,
        showLabel,
        organizerRatings,
        isOrganizerView,
        sportTypeId = sportTypeIds.TENNIS,
        force = {},
        isPickleballRating,
        isItGlobalSearch,
        'data-testid': dataTestId,
    } = props;
    const { ratingType, utrType, verifiedIcon, showDecimals, doNotMask, showProjectedViewStatus } = force;
    const userIsPowered = (auth.user && auth.user.isPowered) || false;
    const rating = getRatingDetails(setRatingChoice({ player, ratingType, utrType }), userIsPowered, showDecimals, doNotMask, showProjectedViewStatus);
    const showPBR = isProgressionDraw !== undefined ? isProgressionDraw && rating.showPBRRating : rating.showPBRRating;
    const isPickleBallSportType = sportTypeId === sportTypeIds.PICKLEBALL;

    const singlePkbRatings = player?.singlespkbrating || player?.historicpkbsinglesrating || player?.singlesPkbRatingDisplay?.pkbRating || player?.utrRange?.pkbRatingDisplay || player?.utrRange?.pickleballRatingDisplay;
    const doublesPkbRatings = player?.doublespkbrating || player?.historicpkbdoublesrating || player?.doublesPkbRatingDisplay?.pkbRating || player?.utrRange?.pkbRatingDisplay || player?.utrRange?.pickleballRatingDisplay;
    const singlePkbisVerified = player?.singlesPkbRatingDisplay?.isVerified;
    const doublesPkbisVerified = player?.doublesPkbRatingDisplay?.isVerified;

    const displayTennisRating = () => {
        if (rating.value === 'UR' && isItGlobalSearch) {
            return (
                <img
                    width={15}
                    src={'/img/v3/icons/icon-no-ratings.svg'}
                    data-testid={dataTestId && `${dataTestId}.unrated-icon`}
                />
            );
        }
        return rating.value;
    };
    const tennisDisplayRating = displayTennisRating();
    let organizerRating;
    let memberOrganizerRating;
    if (organizerRatings) {
        organizerRating = getOrganizerRating(player?.memberId, organizerRatings);
        memberOrganizerRating = ratingType === MatchFormatTypes.SINGLES ? organizerRating?.singlesOrganizerRating : organizerRating?.doublesOrganizerRating;
    }
    const getReliability = (playerRating) => {
        const reliabilityDisplay = getRatingProgressDisplay(playerRating.progress);
        return `(${reliabilityDisplay}%)`;
    };

    if (isPickleballRating) {
        const isSingles = ratingType === MatchFormatTypes.SINGLES;
        const ratings = isSingles ? singlePkbRatings : doublesPkbRatings;
        const isVerified = isSingles ? singlePkbisVerified : doublesPkbisVerified;

        return (
            <div data-testid={dataTestId || undefined}>
                <span>{ratings || (isItGlobalSearch
                    ? (
                        <img
                            width={15}
                            src={'/img/v3/icons/icon-no-ratings.svg'}
                            data-testid={dataTestId && `${dataTestId}.unrated-icon`}
                        />
                    ) : 'UR'
                )}
                </span>
                {ratings && isVerified && <span className="verified15" title="Verified" data-testid={dataTestId && `${dataTestId}.verified-icon`} />}
            </div>
        );
    }

    if (isPickleBallSportType) {
        if (organizerRatings && memberOrganizerRating) {
            return (
                <>
                    <span
                        className="text-danger"
                    >
                        {memberOrganizerRating}
                    </span> ({getPickleBallRating(player, ratingType).value})
                </>
            );
        }

        return (
            <span data-testid={dataTestId || undefined}>
                {getPickleBallRating(player, ratingType).value}
            </span>
        );
    }

    if (isOrganizerView) {
        if (organizerRatings && memberOrganizerRating) {
            return (
                <>
                    <span className="text-danger">{memberOrganizerRating}</span>

                    ( {tennisDisplayRating}
                    {rating.status === ' Projected' ? ' P' : ''})
                </>
            );
        }
        return (
            (showPBR) ? (
                <PbrRating pbrClass={pbrClass} showLabel={showLabel} pbrRating={rating.pbrRating} data-testid={dataTestId && `${dataTestId}.pbr-rating`} />
            ) : (
                <span data-testid={dataTestId || undefined}> {tennisDisplayRating} {rating.value !== 'UR' && rating.status !== 'Unrated' && verifiedIcon && rating.verified ? <span className="verified16" title="Verified" data-testid={dataTestId && `${dataTestId}.verified-icon`} /> : ''}{rating.status === 'Projected' ? getReliability(rating) : ''}
                </span>
            )
        );
    }

    return (
        (showPBR) ? (
            <PbrRating pbrClass={pbrClass} showLabel={showLabel} pbrRating={rating.pbrRating} />
        ) : (
            <>
                {tennisDisplayRating} {rating.value !== 'UR' && rating.status !== 'Unrated' && verifiedIcon && rating.verified ? <span className="verified16" title="Verified" data-testid={dataTestId && `${dataTestId}.verified-icon`} /> : ''}
            </>
        )
    );
};

UtrNumber.propTypes = {
    isPickleballRating: PropTypes.bool,
    player: PropTypes.instanceOf(Object).isRequired,
    isItGlobalSearch: PropTypes.bool,
    'data-testid': PropTypes.string,
};

UtrNumber.defaultProps = {
    isPickleballRating: false,
    isItGlobalSearch: false,
    'data-testid': null,
};
export default withAuth(UtrNumber);
